import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-edd4181a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "coursewrap"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = ["title"];
const _hoisted_4 = {
  class: "menu"
};
const _hoisted_5 = {
  class: "mainwrap"
};
const _hoisted_6 = {
  class: "main"
};
const _hoisted_7 = {
  class: "maintop"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "setting"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "文字大小:", -1));
const _hoisted_11 = {
  class: "mainbodywrap"
};
const _hoisted_12 = {
  class: "mainbody"
};
const _hoisted_13 = {
  class: "maincon"
};
const _hoisted_14 = {
  class: "mainfooter"
};
const _hoisted_15 = {
  class: "attach"
};
const _hoisted_16 = ["href"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-attachent"
}, null, -1));
const _hoisted_18 = {
  class: "movepage"
};
import Csitcoursemenu from '@/components/Csitcoursemenu.vue';
import Csitcoursecon from '@/components/Csitcoursecon.vue';
export default {
  __name: 'sit',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      coursedata: [],
      fontsize: 16,
      curid: 0,
      isshowmenu: true
    });
    let sortindex = 0;
    const coursetree = computed(() => proxy.$common.basic.isarrayexist(data.coursedata) ? settreedata(data.coursedata, 0, 0)[0] : {});
    const coursecur = computed(() => data.curid ? proxy.$common.basic.fffind(data.coursedata, 'id', data.curid) : coursetree.value);
    const menurotate = computed(() => data.isshowmenu ? 180 : 0);
    function getdata() {
      let cid = proxy.$common.basic.chstr2int(proxy.$Cookie.get('sitcurcourseid'));
      data.fontsize = proxy.$common.basic.chstr2int(proxy.$Cookie.get('sitcurcoursefont'), 16);
      let jsondata = {
        'postdata': {
          'act': 'sit_course',
          'sid': 41
        }
      };
      proxy.$common.post(jsondata, res => {
        proxy.$common.each(res.infodata, item => {
          item.x_isopen = false;
          item.x_part = '';
          item.x_children = [];
          item.x_haschildren = false;
          item.x_hassubmenu = false;
          item.x_sort = 0;
          item.x_hasmedia = item.imgs || item.video;
          item.x_imglist = [];
          if (item.imgs) {
            item.x_imglist = item.imgs.split(',');
          }
          if (item.concode) {
            item.concode = proxy.$common.basic.strunformatline(item.concode);
          }
        });
        if (proxy.$common.basic.isarrayexist(res.infodata)) {
          data.coursedata = res.infodata;
          settreedata(data.coursedata, 0, 0, '', true);
          if (data.coursedata.length > 1) {
            //不能在这里用
            data.coursedata.sort((a, b) => a.x_sort - b.x_sort);
          }
          proxy.$nextTick(() => {
            showdetail(cid || coursetree.x_children[0].id);
          });
        }
      });
    }
    function settreedata(listdata, lev, pid, cpart = '', issort = false) {
      let treedata = listdata.filter(item => item.lev == lev && item.pid == pid);
      let cn = 0;
      proxy.$common.each(treedata, item => {
        item.x_isopen = false;
        if (item.ismenu) {
          cn++;
          item.x_part = lev > 0 ? cpart ? cpart + "." + cn : cn : '';
        }
        if (item.ismenu && issort && lev > 0) {
          sortindex++;
          item.x_sort = sortindex;
        }
        item.x_children = settreedata(listdata, lev + 1, item.id, item.x_part, issort);
        item.x_haschildren = proxy.$common.basic.isarrayexist(item.x_children);
        if (item.x_haschildren) {
          item.x_hassubmenu = proxy.$common.basic.fffilter(item.x_children, 'ismenu', 1).length > 0;
        }
      });
      return treedata;
    }
    function savedata() {
      proxy.$Cookie.set('sitcurcourseid', data.curid, -1);
    }
    function fontsizechange(v) {
      proxy.$Cookie.set('sitcurcoursefont', v, -1);
    }
    function showdetail(id) {
      menuopen(id, data.curid);
      data.curid = id;
      proxy.$refs["conscroll"].scrollTo(0, 0);
      savedata();
      let menuscroll = proxy.$refs["menuscroll"];
      window.setTimeout(() => {
        menuscroll.update();
      }, 600); //动画时长是0.5s,动画完成后刷新
    }

    function menuopen(cid, oldid, isfirst = true) {
      let curitem = proxy.$common.basic.fffind(data.coursedata, 'id', cid);
      if (proxy.$common.basic.isobjexist(curitem)) {
        if (curitem.lev > 0) {
          if (cid == oldid) {
            if (isfirst) {
              curitem.x_isopen = !curitem.x_isopen;
            }
          } else {
            curitem.x_isopen = true;
            let olditem = proxy.$common.basic.fffind(data.coursedata, 'id', oldid);
            if (proxy.$common.basic.isobjexist(olditem)) {
              if (curitem.lev == olditem.lev) {
                olditem.x_isopen = false;
              } else if (curitem.lev < olditem.lev) {
                menuopen(cid, olditem.pid, false);
              } else {
                menuopen(curitem.pid, olditem.id, false);
              }
            } else {
              menuopen(curitem.pid, 0, false);
            }
          }
        }
      }
    }
    function showmenu(isshow) {
      data.isshowmenu = isshow == undefined ? !data.isshowmenu : isshow;
    }
    function gopage(n) {
      let nextsort = coursecur.value.x_sort + n;
      if (nextsort > 0) {
        let curitem = proxy.$common.basic.fffind(data.coursedata, 'x_sort', nextsort);
        if (proxy.$common.basic.isobjexist(curitem)) {
          showdetail(curitem.id);
        }
      }
    }
    function keypage(e) {
      switch (e.keyCode) {
        case 37:
          //left
          gopage(-1);
          break;
        case 39:
          //right
          gopage(1);
          break;
      }
    }
    function getfilename(str) {
      let v = str;
      let mp = str.lastIndexOf('/');
      if (mp > 0) {
        v = str.substring(mp + 1);
        let mn = v.lastIndexOf('.');
        if (mn > 0) {
          v = v.substring(0, mn);
        }
      }
      return v;
    }
    onUnmounted(() => {
      window.removeEventListener('keyup', keypage);
      savedata();
    });
    onMounted(() => {
      getdata();
      window.addEventListener('keyup', keypage);
      window.addEventListener('beforeunload', savedata);
    });
    return (_ctx, _cache) => {
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_slider = _resolveComponent("el-slider");
      const _directive_viewer = _resolveDirective("viewer");
      return _openBlock(), _createElementBlock("div", {
        class: "appfull modulewrap",
        style: _normalizeStyle({
          fontSize: _unref(data).fontsize + 'px'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "side",
        style: _normalizeStyle({
          width: (_unref(data).isshowmenu ? 240 : 0) + 'px'
        })
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        class: "overdot",
        title: _unref(coursetree).title
      }, _toDisplayString(_unref(coursetree).title), 9, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_scrollbar, {
        class: "scroll",
        ref: "menuscroll"
      }, {
        default: _withCtx(() => [_createVNode(Csitcoursemenu, {
          curid: _unref(data).curid,
          infolist: _unref(coursetree).x_children,
          onShowdetail: showdetail
        }, null, 8, ["curid", "infolist"])]),
        _: 1
      }, 512)]), _createElementVNode("div", {
        class: "switch",
        onClick: _cache[0] || (_cache[0] = $event => showmenu())
      }, [_createElementVNode("i", {
        class: "iconfont icon-fanye1",
        style: _normalizeStyle({
          transform: 'rotate(' + _unref(menurotate) + 'deg)'
        })
      }, null, 4)])], 4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(coursecur).x_part) + " " + _toDisplayString(_unref(coursecur).title), 1), _createElementVNode("dl", _hoisted_9, [_hoisted_10, _createElementVNode("dd", null, [_createVNode(_component_el_slider, {
        modelValue: _unref(data).fontsize,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(data).fontsize = $event),
        min: 12,
        max: 36,
        onChange: fontsizechange
      }, null, 8, ["modelValue"])])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_scrollbar, {
        class: "scroll",
        ref: "conscroll"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(Csitcoursecon, {
          coursecur: _unref(coursecur)
        }, null, 8, ["coursecur"])])])]),
        _: 1
      }, 512)])), [[_directive_viewer]]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_unref(coursecur).attach ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _unref(coursecur).attach
      }, [_hoisted_17, _createTextVNode(_toDisplayString(getfilename(_unref(coursecur).attach)) + "下载", 1)], 8, _hoisted_16)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("a", {
        href: "#",
        onClick: _cache[2] || (_cache[2] = $event => gopage(-1))
      }, "上一页"), _createElementVNode("a", {
        href: "#",
        onClick: _cache[3] || (_cache[3] = $event => gopage(1))
      }, "下一页")])])])])])], 4);
    };
  }
};